/* eslint-disable max-len */
import React, { useState } from "react";
import ReactDOM from "react-dom";

import { useNavigate } from "react-router-dom";

import { Button } from "../../kaya";
import { routesConstants } from "../../constants";
import userStore from "../../zustand/user.store";
import { appActions, userActions } from "../../actions";
import { findIndex, get } from "lodash";
import { storeUserInIndexDB } from "../../helpers/indexDb.helpers";
import playlistStore from "../../zustand/playlist.store";
import likedSongsStore from "../../zustand/likedSong.store";
import disLikedSongsStore from "../../zustand/dislikedSong.store";
import favoriteSongStore from "../../zustand/favoriteSong.store";
import ignoredSongStore from "../../zustand/ignoreSong.store";
import SchedulesStore from "../../zustand/Schedule.store";
import musicPlayerStore from "../../zustand/musicPlayer.store";

import styles from "./TermsAndCondition.module.scss";

const TermsAndCondition = (props) => {
  const { visible, setVisible } = props;

  const navigate = useNavigate();

  const {
    setAuthentication,
    user: userData,
    userOffline,
    setUser,
  } = userStore();
  const { setPlaylists } = playlistStore((state) => ({
    setPlaylists: state.setPlaylists,
  }));
  const { setSongs: setLikedSongs } = likedSongsStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setDislikeSongs } = disLikedSongsStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setFavouriteSongs } = favoriteSongStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setIgnoredSongs } = ignoredSongStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSchedules } = SchedulesStore((state) => ({
    setSchedules: state.setSchedules,
  }));
  const { setSongs, setPlayList, toggleIsShuffle } = musicPlayerStore(
    (state) => {
      return {
        setSongs: state.setSongs,
        setPlayList: state.setPlayList,
        toggleIsShuffle: state.toggleIsShuffle,
      };
    }
  );

  const [isLoading, setIsLoading] = useState(false);

  // const inputRef = useRef(null);

  // const hadnleImage = async (e) => {
  //   const file = e.target.files?.[0];

  //   if (!file) {
  //     return;
  //   }

  //   setFormValues({
  //     ...formvalues,
  //     signature: file,
  //     signatureUrl: URL.createObjectURL(file),
  //   });
  // };

  // const handleUploadSong = async () => {
  //   const payload = uploadMusicHelpers.uplaodSongPayload(formvalues);

  //   setIsLoading(true);

  //   const data = await songActions.uploadSongAction({ payload });
  //   setIsLoading(false);

  //   if (data.success) {
  //     navigate(routesConstants.ROUTES.UPLOAD_MUSIC);
  //     setIsUploadDone(true);
  //     addSong(get(data, "data", ""));

  //     setFormValues(uploadMusicTypes.INITIAL_STATE);
  //   }
  // };

  const handleSubmit = async () => {
    //update user remaining
    setIsLoading(true);

    // Call the Initiate Payment API
    const initiatePaymentRes = await userActions.initiatePaymentAction(
      { plan_type: userData.plan.type },
      userOffline
    );

    if (initiatePaymentRes.success) {
      const checkout = get(initiatePaymentRes, "data", null);
      const url = get(initiatePaymentRes, "data.url", "");
      const transactionId =
        get(initiatePaymentRes, "data.transactionId", "") ||
        get(initiatePaymentRes, "data.transaction_id", "");
      try {
        if (transactionId && checkout) {
          sessionStorage.setItem(
            `billing:checkout:${transactionId}`,
            JSON.stringify(checkout)
          );
        }
      } catch (e) {
        // ignore
      }
      navigate(
        `/payment?paymentUrl=${encodeURIComponent(
          url
        )}&transactionId=${encodeURIComponent(transactionId)}`
      ); // Navigate to iframe page instead of open
    }
    // } else {
    //   const {
    //     user,
    //     playlists,
    //     status,
    //     likedSongs,
    //     schedules,
    //     songs,
    //     ignoredSongs,
    //     favoritePlaylist,
    //     favouriteSongs,
    //     dislikedSongs,
    //   } = await appActions.fetchAppData(get(userData, "id", ""), userOffline);

    //   const index = findIndex(
    //     favoritePlaylist.songs,
    //     (song) => get(song, "id", "") === get(status, "last_played_song", "")
    //   );
    //   setUser(user);
    //   await storeUserInIndexDB(user, "user-data");

    //   setPlaylists(playlists);
    //   setLikedSongs(likedSongs);
    //   setDislikeSongs(dislikedSongs);
    //   setFavouriteSongs(favouriteSongs);
    //   setSchedules(schedules);
    //   setSongs(songs);
    //   setIgnoredSongs(ignoredSongs);
    //   setPlayList(favoritePlaylist, index);
    //   toggleIsShuffle(status.last_shuffled);

    //   setAuthentication({
    //     isAuthenticated: true,
    //     isPhoneVerified: true,
    //     isBusinessVerified: true,
    //     isPrimium: true,
    //   });

    //   setIsLoading(false);

    //   navigate(routesConstants.ROUTES.PREMIUM_USER);
    // }
  };

  return visible ? ReactDOM.createPortal(
    <div className={styles.portalContainer}>
      <div className={styles.backdrop} onClick={() => setVisible(false)} />
      <div className={styles.TermsAndCondition}>
        <p className={styles.tnc}>Terms and Condition</p>
        <p className={styles.lastUpdated}>Last Updated: January 16, 2023</p>

        <div className={styles.description}>
          <h1>4Play Terms of Use</h1>

          <section>
            <h2>1. Introduction</h2>
            <p>
              These Terms of Use (“Terms”) govern your use of 4Play’s music
              streaming services, applications, and all other services we
              provide (collectively, the “4Play Service” or “Service”). By
              signing up for, accessing, or using 4Play, you are entering a
              legally binding contract with 4Play.
            </p>
          </section>

          <section>
            <h2>2. The 4Play Service</h2>
            <p>
              4Play provides businesses with access to curated music playlists
              for background streaming, ensuring that all music played is fully
              licensed by 4Play. This means businesses using our Service do not
              need to make additional copyright payments to third parties. The
              4Play Service is for business use only and should not be used for
              personal purposes.
            </p>
            <ul>
              <li>
                <strong>Business Use:</strong> 4Play is designed specifically
                for use in business environments. Any attempt to use 4Play’s
                music outside of a business setting is a violation of these
                Terms.
              </li>
              <li>
                <strong>Repertoire:</strong> 4Play owns 100% of the music on its
                platform and does not permit users to upload their own content.
                By using the Service, you agree that the music played will come
                solely from 4Play’s licensed catalog.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Your Account</h2>
            <p>
              To access 4Play, you will need to create an account. You must
              provide accurate and current information and maintain the security
              of your account. You are responsible for all activity on your
              account and must notify 4Play immediately if any unauthorized use
              is detected.
            </p>
            <ul>
              <li>
                <strong>Single-Device Subscription:</strong> Each subscription
                is limited to playback on a single device at a single business
                location. If you operate multiple business locations, a separate
                subscription is required for each location.
              </li>
              <li>
                <strong>No Sharing:</strong> You may not share your
                subscription, transfer it to others, or duplicate it. Attempting
                to do so may result in termination of your account.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Payments and Cancellation</h2>
            <ul>
              <li>
                <strong>Subscription Fees:</strong> You will be billed on the
                1st of each month for your subscription. The fees cover the use
                of 4Play’s music at a single business location. Subscription
                fees are non-refundable, except as required by law.
              </li>
              <li>
                <strong>Free Trial:</strong> New users are eligible for a 10-day
                free trial. After the trial period, your credit card will be
                charged automatically unless you cancel the Service before the
                trial ends.
              </li>
              <li>
                <strong>Cancellation:</strong> You can cancel your subscription
                at any time through your account settings. Your subscription
                will remain active until the end of the current billing cycle.
                No refunds will be given for any remaining time in the billing
                period after cancellation. The cancellation will take effect at
                the start of the following billing period.
              </li>
              <li>
                <strong>Failure to Pay:</strong> If you fail to pay the
                subscription fee, your access to the 4Play Service will be
                suspended, and 4Play reserves the right to terminate your
                account.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Rights We Grant You</h2>
            <p>
              4Play grants you a limited, non-exclusive, and revocable right to
              access and use the 4Play Service. This access is provided for the
              duration of your subscription and for the purpose of playing music
              in your business environment. You agree to comply with all laws
              and regulations in using the Service.
            </p>
            <ul>
              <li>
                <strong>Restrictions:</strong> You are prohibited from
                reverse-engineering, decompiling, or tampering with the 4Play
                Service. Additionally, you may not use the Service in a way that
                violates copyright or other intellectual property rights.
              </li>
            </ul>
          </section>

          <section>
            <h2>6. Content and Intellectual Property</h2>
            <p>
              All music, software, and content available through the 4Play
              Service are owned by 4Play or its licensors. You may not copy,
              redistribute, or alter any content from the 4Play Service.
            </p>
            <ul>
              <li>
                <strong>User-Generated Playlists:</strong> While you can create
                personalized playlists from the 4Play repertoire, all playlists
                and associated data are the property of 4Play. This includes
                information about which songs you have played, liked, or
                disliked.
              </li>
              <li>
                <strong>Data Collection:</strong> 4Play collects information
                about the songs played in your business for internal reporting
                and optimization of its Service. This information may be used
                for analytical purposes and to improve user experience.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Third-Party Rights</h2>
            <p>
              4Play has agreements with artists and music providers to create
              its repertoire. Users are prohibited from attempting to play
              4Play’s music through any means other than the official Service.
              Violation of these terms may result in termination of the account
              and legal action for copyright infringement.
            </p>
          </section>

          <section>
            <h2>8. Termination</h2>
            <p>
              4Play may terminate or suspend your access to the Service at any
              time, with or without cause. Reasons for termination may include,
              but are not limited to, failure to pay fees, breach of these
              Terms, or suspected violations of copyright laws. If your account
              is terminated, you will not be entitled to a refund.
            </p>
          </section>

          <section>
            <h2>9. Privacy and Data Collection</h2>
            <p>
              By using the 4Play Service, you consent to the collection and use
              of personal information as outlined in our Privacy Policy. This
              includes the collection of contact information, billing
              information, and data on how you interact with the Service.
            </p>
          </section>

          <section>
            <h2>10. Warranty Disclaimer</h2>
            <p>
              The 4Play Service is provided “as is” and without warranties of
              any kind. We do not guarantee that the Service will be
              uninterrupted, error-free, or free from viruses. To the maximum
              extent permitted by law, 4Play disclaims all warranties, whether
              express or implied, including those of merchantability, fitness
              for a particular purpose, and non-infringement.
            </p>
          </section>

          <section>
            <h2>11. Limitation of Liability</h2>
            <p>
              To the extent permitted by law, 4Play will not be liable for any
              indirect, incidental, or consequential damages arising out of or
              related to your use of the Service. This includes, but is not
              limited to, loss of profits, business interruption, or damage to
              reputation.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Israel. Any
              disputes arising out of or related to these Terms will be subject
              to the exclusive jurisdiction of the courts of Israel.
            </p>
          </section>

          <section>
            <h2>13. Changes to the Terms</h2>
            <p>
              4Play reserves the right to update or modify these Terms at any
              time. If we make material changes, we will provide notice through
              the Service or via email. Your continued use of the 4Play Service
              after any changes become effective constitutes acceptance of the
              revised Terms.
            </p>
          </section>

          <section>
            <h2>14. Contact Information</h2>
            <p>
              If you have any questions about these Terms or the 4Play Service,
              please contact us at info@4-play.io
            </p>
          </section>

          {/* -------------------------------------------------------------------------------------------- */}

          <h1>4Play Privacy Policy</h1>

          <section>
            <h2>1. Introduction</h2>
            <p>
              At 4Play, we value your privacy. This Privacy Policy explains how
              we collect, use, and protect your personal data when you use our
              services. By using the 4Play platform, you agree to the terms
              described here.
            </p>
            <p>
              This policy applies to all services provided by 4Play, including
              but not limited to music streaming, personalized playlist
              creation, and business data analytics. We encourage you to read
              this policy carefully to understand our practices regarding your
              personal data and how we will treat it.
            </p>
          </section>

          <section>
            <h2>2. Data We Collect</h2>
            <p>
              To provide our service, we collect several types of data,
              including:
            </p>
            <ul>
              <li>
                <strong>Account Information:</strong> When you register for
                4Play, we collect personal details such as your name, email
                address, and business information.
              </li>
              <li>
                <strong>Payment Information:</strong> For subscription purposes,
                we collect credit card details. These are securely processed and
                stored by Tranzila, our payment processor.
              </li>
              <li>
                <strong>Usage Data:</strong> We collect information on how you
                interact with our Service, including the playlists you create,
                the songs you like or dislike, and the playback reports showing
                which music was played, when, and where.
              </li>
              <li>
                <strong>Technical Data:</strong> Information such as your
                device, IP address, and connection type is collected to help us
                improve the service and troubleshoot issues.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Data</h2>
            <p>We use the data we collect for the following purposes:</p>
            <ul>
              <li>
                <strong>Service Provision:</strong> To enable you to access and
                use the 4Play platform, including managing your account and
                subscription, delivering music content, and customizing your
                experience.
              </li>
              <li>
                <strong>Personalization:</strong> To offer personalized
                playlists and recommendations based on your usage patterns and
                preferences.
              </li>
              <li>
                <strong>Billing and Payments:</strong> To process your
                subscription fees and ensure secure transactions via our payment
                processor.
              </li>
              <li>
                <strong>Business Analytics:</strong> To gather insights on how
                4Play is being used, such as which songs are popular, and
                generate reports for business optimization.
              </li>
              <li>
                <strong>Communications:</strong> To send you service-related
                emails, such as account updates, billing confirmations, and
                technical notices.
              </li>
              <li>
                <strong>Legal Compliance:</strong> To meet legal obligations,
                including processing personal data for tax and compliance
                purposes.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Sharing Your Data</h2>
            <p>
              We do not sell your personal data. However, we may share it with:
            </p>
            <ul>
              <li>
                <strong>Service Providers:</strong> These include payment
                processors (such as Tranzila) and cloud service providers that
                help us store and manage your data securely.
              </li>
              <li>
                <strong>Business Partners:</strong> We may share anonymized or
                aggregated data with our partners, such as artists or playlist
                curators, to help them understand how their music is being used.
              </li>
              <li>
                <strong>Legal Authorities:</strong> If required by law or if we
                believe that it is necessary to protect our legal rights, we may
                disclose your information to regulatory authorities or law
                enforcement agencies.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              4Play takes the security of your data seriously. We use a variety
              of security measures, including encryption and secure storage, to
              ensure your personal information is protected from unauthorized
              access, use, or disclosure. All sensitive data, including credit
              card information, is processed and stored through our payment
              partner, Tranzila, in compliance with industry standards.
            </p>
            <p>
              While we take steps to safeguard your data, no security system is
              completely foolproof, and we cannot guarantee the absolute
              security of your information.
            </p>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We retain your personal data for as long as necessary to provide
              you with the 4Play Service and fulfill the purposes outlined in
              this Privacy Policy. When we no longer need to retain your data,
              we will delete or anonymize it, unless we are required to retain
              it to comply with legal obligations.
            </p>
            <ul>
              <li>
                <strong>Account Information:</strong> Retained as long as your
                account is active or as needed to provide you with the 4Play
                Service.
              </li>
              <li>
                <strong>Payment Information:</strong> Stored securely for as
                long as required for subscription billing purposes.
              </li>
              <li>
                <strong>Usage Data:</strong> Retained for analytical purposes to
                improve the service and provide insights to our business
                partners.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>
              Depending on the laws in your jurisdiction, you may have certain
              rights regarding your personal data, such as:
            </p>
            <ul>
              <li>
                <strong>Access:</strong> You have the right to request a copy of
                the personal data we hold about you.
              </li>
              <li>
                <strong>Correction:</strong> If any of your information is
                incorrect or outdated, you can request that it be corrected.
              </li>
              <li>
                <strong>Deletion:</strong> You may request the deletion of your
                personal data, subject to legal or contractual obligations.
              </li>
              <li>
                <strong>Restriction:</strong> You have the right to restrict how
                your data is used under certain conditions.
              </li>
              <li>
                <strong>Objection:</strong> You may object to the processing of
                your personal data for certain purposes, such as direct
                marketing.
              </li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at
              info@4-play.io.
            </p>
          </section>

          <section>
            <h2>8. Data Transfers</h2>
            <p>
              As 4Play is based in Israel, your personal data may be transferred
              and processed outside your country of residence. We ensure that
              any such transfers comply with applicable privacy laws and that
              appropriate safeguards are in place to protect your data.
            </p>
          </section>

          <section>
            <h2>9. Children&apos;s Privacy</h2>
            <p>
              4Play is not intended for use by children under the age of 18. We
              do not knowingly collect personal data from individuals under 18.
              If we become aware that we have collected data from a minor, we
              will delete it promptly.
            </p>
          </section>

          <section>
            <h2>10. Changes to the Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time in response to
              evolving legal, technical, or business developments. When we make
              changes, we will notify you via email or through the Service. It
              is important to review any changes to this Privacy Policy to
              ensure you are aware of how your personal data is handled.
            </p>
          </section>

          <section>
            <h2>11. Contact Information</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy or
              your data privacy rights, please contact us at info@4-play.io.
            </p>
          </section>

          {/* -------------------------------------------------------------------------------------------- */}
          <h1>4Play User Guidelines</h1>

          <p>
            These guidelines outline how to responsibly and legally use the
            4Play platform. We ask all users to respect the rights of others and
            adhere to these rules to ensure a smooth, enjoyable experience for
            everyone.
          </p>

          <section>
            <h2>1. Accessing 4Play</h2>
            <p>
              To use 4Play, you must create an account and subscribe to our
              service. You agree to provide accurate, up-to-date information.
              Sharing your account details with others or using someone
              else&apos;s account without permission is prohibited. You are
              responsible for keeping your account secure, and any activity on
              your account is your responsibility. Notify us immediately if you
              believe your account has been compromised.
            </p>
          </section>

          <section>
            <h2>2. Acceptable Use of 4Play</h2>
            <p>
              4Play is designed for business use only. Each subscription is
              limited to one device and one business location. Users are not
              permitted to share or duplicate subscriptions across multiple
              locations without purchasing additional subscriptions. Any attempt
              to bypass these restrictions, including the use of multiple
              devices, is a violation of these guidelines.
            </p>
            <ul>
              <li>
                <strong>Business Environments Only:</strong> 4Play’s music
                service is strictly for use in business settings. Using the
                service in a non-business environment is a breach of these
                guidelines and may result in the termination of your account.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Intellectual Property and Content Usage</h2>
            <p>
              The music and content available on 4Play are fully owned by 4Play
              and its partners. By using the service, you agree to respect the
              intellectual property rights of the platform and the content
              creators.
            </p>
            <ul>
              <li>
                <strong>No Copying or Downloading:</strong> Users are strictly
                prohibited from copying, downloading, recording, or distributing
                any of the content available on the platform. This includes
                attempts to capture audio using external devices or software.
              </li>
              <li>
                <strong>Personalized Playlists:</strong> You may create
                personalized playlists using 4Play’s repertoire, but you cannot
                share, sell, or otherwise distribute these playlists. All
                playlist data, including your preferences and the songs played,
                are the property of 4Play.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Prohibited Activities</h2>
            <p>
              You are not permitted to engage in any activity that violates the
              law, infringes on the rights of others, or interferes with the
              operation of 4Play. This includes:
            </p>
            <ul>
              <li>
                <strong>Hacking or Tampering:</strong> Any attempts to bypass
                security measures, reverse-engineer the platform, or otherwise
                tamper with the service are strictly prohibited.
              </li>
              <li>
                <strong>Fraudulent Activity:</strong> You must not engage in any
                fraudulent activity, including creating fake accounts, using
                false payment information, or manipulating usage data.
              </li>
              <li>
                <strong>Automated Systems:</strong> The use of bots, scrapers,
                or other automated systems to interact with 4Play is not
                allowed. Any attempt to collect data from the platform using
                unauthorized methods is a breach of these guidelines.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Reporting and Analytics</h2>
            <p>
              4Play collects data on your usage of the platform, including the
              songs played in your business, the playlists you create, and your
              preferences. This data is used for internal analytics and business
              improvement purposes. You may not manipulate or artificially
              inflate play counts, likes, or other metrics.
            </p>
          </section>

          <section>
            <h2>6. Privacy and Data Protection</h2>
            <p>
              Respect the privacy of others when using 4Play. Do not share
              personal information, account details, or sensitive business data
              with unauthorized third parties. Any misuse of personal data will
              result in immediate account suspension and possible legal action.
            </p>
            <ul>
              <li>
                <strong>Data Security:</strong> 4Play implements security
                measures to protect your data. However, it is your
                responsibility to keep your account information confidential.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Enforcement and Penalties</h2>
            <p>Failure to comply with these User Guidelines may result in:</p>
            <ul>
              <li>
                <strong>Warnings:</strong> Minor violations may result in a
                warning from 4Play, with instructions on how to correct the
                issue.
              </li>
              <li>
                <strong>Account Suspension or Termination:</strong> Serious or
                repeated violations, including any form of copyright
                infringement or fraudulent behavior, may result in the
                suspension or termination of your account without prior notice.
              </li>
              <li>
                <strong>Legal Action:</strong> In cases of criminal activity,
                such as copyright infringement or unauthorized distribution of
                content, 4Play reserves the right to take legal action against
                the offending party.
              </li>
            </ul>
          </section>

          <section>
            <h2>8. Reporting Violations</h2>
            <p>
              If you believe another user is violating these guidelines, you can
              report the behavior to 4Play by contacting us at info@4-play.io.
              We take all reports seriously and will investigate any potential
              violations.
            </p>
          </section>

          <section>
            <h2>9. Changes to the Guidelines</h2>
            <p>
              4Play reserves the right to update or modify these User Guidelines
              at any time. If changes are made, we will notify users via email
              or through the platform. Continued use of the service after
              changes are made constitutes acceptance of the updated guidelines.
            </p>
          </section>

          <section>
            <h2>10. Contact Information</h2>
            <p>
              If you have any questions or concerns about these User Guidelines
              or how to use the 4Play service, please contact us at
              info@4-play.io.
            </p>
          </section>
        </div>
        <div className={styles.btnContainer}>
          <Button
            type="Outline"
            width="200px"
            onClick={() => {
              setVisible(false);
            }}
          >
            Decline
          </Button>

          <Button
            type="Primary"
            width="200px"
            onClick={handleSubmit}
            isLoading={isLoading}
          >
            Accept
          </Button>
        </div>
      </div>
    </div>,
    document.body
  ) : null;
};

export default TermsAndCondition;
